export enum CoverageQuestionNames {
  INSURANCE_COVERAGE = 'Zakres ubezpieczenia',
  INSURED_SUM = 'Suma ubezpieczenia',
  LIFE_EXAMPLES = 'Przykłady z życia',
  DAMAGE_PROTECTION = 'Jak zabezpieczyć się przed szkodą?',
  NOT_INSURED = 'Kiedy ubezpieczenie nie działa?',
  DAMAGE_CASE = 'Co zrobić w przypadku szkody?',
}
